import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: { wrapper: '', spinner: 'w-5 h-5', border: 'border-2' },
  md: { wrapper: 'min-h-[40vh]', spinner: 'w-10 h-10', border: 'border-[3px]' },
  lg: { wrapper: 'min-h-[60vh]', spinner: 'w-12 h-12', border: 'border-[3px]' },
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'lg', className = '' }) => {
  const s = sizeMap[size];

  if (size === 'sm') {
    return (
      <div className={`inline-flex items-center justify-center ${className}`}>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
          className={`${s.spinner} ${s.border} border-stone-200 border-t-royal-gold rounded-full`}
        />
      </div>
    );
  }

  return (
    <div className={`${s.wrapper} flex items-center justify-center ${className}`}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex flex-col items-center gap-4"
      >
        <div className={`relative ${s.spinner}`}>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            className={`absolute inset-0 ${s.border} border-stone-200 border-t-royal-gold rounded-full`}
          />
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="text-sm text-royal-text-secondary"
        >
          Loading...
        </motion.p>
      </motion.div>
    </div>
  );
};
